import React from "react";
import { Box, Grid } from "@mui/material";
import ModelViewer from "../ModelViewer/ModelViewer";
import LoadingAnimation from "../LoadingAnimation"

function DesignChoicePage({
  models,
  pendingModels,
  error,
  viewStates,
  updateViewState,
  handleModelSelect,
}) {
  const seenCodes = new Set();
  // Always show failures (so it's visible when a generation errors out).
  // Only dedupe identical code among successful generations.
  const modelsToShow = models.filter((model) => {
    if (model.status !== "SUCCESS") {
      return true;
    }
    if (seenCodes.has(model.code)) {
      return false;
    }
    seenCodes.add(model.code);
    return true;
  });

  const isOdd = (modelsToShow.length % 2) === 1

  return (
    <Box my={4}>
      <Grid container spacing={3} justifyContent="center" sx={{ width: "100%" }}>
        {modelsToShow.map((model, index) => (
          <Grid size={{ xs: 12, md: 6, lg: 6 }} key={index} sx={{ minWidth: 400 }}>
            <ModelViewer
              modelNum={models.indexOf(model)} // Original index
              model={model}
              error={error}
              viewStates={viewStates}
              updateViewState={updateViewState}
              handleModelSelect={handleModelSelect}
              dedupedModelId={index} // User-facing ID
            />
          </Grid>
        ))}
        {(isOdd || pendingModels) && (
          <Grid size={{ xs: 12, md: 6, lg: 6 }} sx={{ minWidth: 400 }}>
            {pendingModels && (
              <Box sx={{
                width: '100%',
                height: '676px',
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
                <LoadingAnimation />
              </Box>)}
          </Grid>
        )}
      </Grid>
    </Box>
  );
}

export default DesignChoicePage;
